import { Toaster } from 'sonner';
import styles from './Toasts.module.css';

// Поряд із роутером, не в оболонці: тости потрібні й до входу.
export function Toasts() {
  return (
    <Toaster
      // Угорі праворуч кнопки дій — тост накривав би щойно натиснуте.
      position="bottom-right"
      theme="system"
      toastOptions={{
        classNames: {
          toast: styles.toast,
          title: styles.title,
          description: styles.description,
          error: styles.error,
          success: styles.success,
          closeButton: styles.close,
        },
      }}
      closeButton
      gap={10}
    />
  );
}
